<template>
  <div id="calendar">
    <v-layout justify-space-between align-center>
      <v-flex shrink>
        <v-layout align-center>
          <v-flex shrink class='mr-3 mb-6'>
            <div class='font-18 font-w-600'>ปฎิทินทางการตลาด</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <DaterangeBtn v-model="daterange"/>
        </v-col>
        <v-col class="text-right d-none d-md-block">
          <DownloadBtn :daterange="daterange"/>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="mt-4 mb-5" />
    <FilterForm
      :daterange="daterange"
      @filter="onFilter"/>
    <ContentDayList
      v-if="daterange=='day'"
      :promotions="filtered"
      :form="form"/>
    <ContentWeekGantt
      v-else-if="daterange=='week' && display == 'gantt'"
      :promotions="filtered"
      :form="form"
      @changeDisplay="onChangeDisplay"/>
    <ContentWeekCalendar
      v-else-if="daterange=='week' && display == 'calendar'"
      :promotions="filtered"
      :form="form"
      @changeDisplay="onChangeDisplay"/>
    <ContentMonthGantt
      v-else-if="daterange=='month' && display == 'gantt'"
      :promotions="filtered"
      :form="form"
      @changeDisplay="onChangeDisplay"/>
    <ContentMonthCalendar
      v-else-if="daterange=='month' && display == 'calendar'"
      :promotions="filtered"
      :form="form"
      @changeDisplay="onChangeDisplay"/>
    <ContentYearGantt
      v-else-if="daterange=='year' && display == 'gantt'"
      :promotions="filtered"
      :form="form"
      @changeDisplay="onChangeDisplay"/>
  </div>
</template>

<script>
import promotionsJson from '@/store/promotions.json'
import moment from 'moment'
import { mapGetters } from 'vuex'

import { controllerName } from '@/store/constants';

import DaterangeBtn from '@/components/calendar/sub/DaterangeBtn.vue'
import DownloadBtn from '@/components/calendar/sub/DownloadBtn.vue'
import FilterForm from '@/components/calendar/FilterForm.vue'
import ContentDayList from '@/components/calendar/ContentDayList.vue'
import ContentWeekGantt from '@/components/calendar/ContentWeekGantt.vue'
import ContentWeekCalendar from '@/components/calendar/ContentWeekCalendar.vue'
import ContentMonthGantt from '@/components/calendar/ContentMonthGantt.vue'
import ContentMonthCalendar from '@/components/calendar/ContentMonthCalendar.vue'
import ContentYearGantt from '@/components/calendar/ContentYearGantt.vue'

export default {
  components: {
    DaterangeBtn,
    DownloadBtn,
    FilterForm,
    ContentDayList,
    ContentWeekGantt,
    ContentWeekCalendar,
    ContentMonthGantt,
    ContentMonthCalendar,
    ContentYearGantt,
  },
  data() {
    return {
      daterange: 'day',
      display: 'gantt',
      form:{},
      filtered:[],
    }
  },
  created() {
    this.$store.commit('Calendar/initTypes')
    this.getPromotionMaster()
  },
  watch: {
    daterange() {
      this.display = 'gantt'
      this.onFilter(this.form)
    },
  },
  methods: {
    getPromotionMaster() {
      this.$store.commit('General/setLoading')

      this.$store.commit('Calendar/setPromotions', promotionsJson)
      this.$store.commit('General/setLoading', false)

      // this.$lc.callApex(`${controllerName}.getPromotionMaster`,
      //   null,
      //   (res, event) => {
      //     console.log('event: ', event)
      //     console.log('getPromotionMaster: ', res)
      //     this.$store.commit('Calendar/setPromotions', promotionsJson)
      //   })
    },
    onFilter(form) {
      const filterFn = {
        day: this.filterDay,
        week: this.filterWeek,
        month: this.filterMonth,
        year: this.filterYear,
      }
      this.form = form
      filterFn[this.daterange](form)
    },
    onChangeDisplay(display){
      this.display = display
    },
    filterDay(form) {
      const date = moment(new Date(form.year, form.month, form.day))
      this.filter(date, date, form)
    },
    filterWeek(form) {
      const date = new Date(form.year, form.month, form.day)
      const day = moment(date).day()
      const from = moment(date).subtract((day+6)%7, 'day')
      const to = moment(date).add((7 - day)%7, 'day')
      this.filter(from, to, form)
    },
    filterMonth(form) {
      const date = new Date(form.year, form.month, 1)
      const from = moment(date)
      const to = moment(date).date(from.daysInMonth())
      this.filter(from, to, form)
    },
    filterYear(form) {
      const from = moment(new Date(form.year, 0, 1))
      const to = moment(new Date(form.year, 11, 31))
      this.filter(from, to, form)
    },
    filter(from, to, form) {
      this.filtered = this.promotions.filter(promotion => {
        if (form.itemIds.includes(promotion.Id)) return true
        if (!form.types.includes(promotion.PromotionType__c)) return false

        const start = moment(promotion.StartDate__c)
        if (to < start) return false

        if ('EndDate__c' in promotion) {
          const end = moment(promotion.EndDate__c)
          if (from > end) return false
        }

        return true
      })
    },
  },
  computed: {
    ...mapGetters({
      promotions: 'Calendar/getPromotions',
      types: 'Calendar/getTypes',
      typeKeys: 'Calendar/getTypeKeys',
    })
  }
};
</script>

<style lang='scss'>
#calendar {
  .v-card {
    overflow: hidden;
  }
  .row-header {
    background-color: #F4F6F8;
    border-bottom: 1px solid #DFE3E8;
    .promo-head2 {
      overflow-x: hidden;
      .row {
        position: relative;
        max-width: none;
      }
    }
  }
  .v-avatar.active{
    color: white;
  }
  .weekend {
    background-color: #DFE3E8;
  }
  .type-title {
    border-bottom: 1px solid #DFE3E8;
  }
  .content {
    .col {
      border-right: 1px solid #DFE3E8;
      &.no-border,
      &:last-child{
        border-right: none;
      }
    }

    .promo-info {
      position: relative;
      height: 500px;
      overflow-y: auto;
      .promo-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
      }
    }
    .promo-gantt {
      position: relative;
      height: 500px;
      overflow-y: hidden;
      .row {
        position: relative;
        max-width: none;
      }
      .col.width-50 {
        flex: 0 0 50px;
      }
      .bar {
        position: absolute;
        color: white;
        border-radius: 5px;
        height: 24px;
        left:50%;
        right:50%;
        transition: top 0.6s, left 0.6s, right 0.6s;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .promo-calendar {
      position: relative;

      &.week {
        height: 500px;
      }

      &.month {
        .row.week {
          position: relative;
          height: 112px;
          border-bottom: 1px solid #DFE3E8;
          .month-diff {
            color: #DFE3E8;
          }
          .more {
            border-radius: 5px;
            height: 16px;
            margin: 0 2px 8px;
            background-color: #E5E8EB;
            cursor: pointer;
          }
        }
      }

      .bar {
        position: absolute;
        color: white;
        border-radius: 5px;
        height: 16px;
        left:50%;
        right:50%;
        transition: top 0.6s, left 0.6s, right 0.6s;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
